import { useDiorama } from "../../../contexts/DioramaContext";

const TextCustomizer: React.FC = () => {
	const { state, dispatch } = useDiorama();

	const handleTextChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
		dispatch({ type: "UPDATE_TEXT", text: e.target.value });
	};

	return (
		<div>
			<h2 className="text-xl font-semibold mb-4">Step 3: Add Message</h2>
			<p className="mb-4">Customize the message for your diorama</p>

			<div className="space-y-4">
				<div>
					<label htmlFor="text" className="block mb-1 font-medium">
						Message Content
					</label>
					<textarea
						id="text"
						value={state.text}
						onChange={handleTextChange}
						className="w-full p-2 border rounded focus:ring focus:ring-blue-300 focus:outline-none break-after-auto"
						rows={3}
						maxLength={50}
						placeholder="Enter your text here..."
					/>
				</div>
			</div>
		</div>
	);
};

export default TextCustomizer;
